import { LocaleContext } from 'components/MainComponent/MainComponent'
import { PromilleTabelle } from 'components/PromilleTabelle'
import { ReactNode, useContext, useEffect, useState } from 'react'
import styled from 'styled-components'

const sortValues = { beer: 1, wine: 2, snaps: 3 }

export const PromilleRechner = ({
  colorMode,
}: {
  colorMode: 'dark' | 'light' | undefined
}) => {
  const [values, setValues] = useState<{
    alcohol: number
    weight: number
    size: number
    time: number
    gender: 'm' | 'f'
  }>({ alcohol: 0, weight: 0, size: 0, time: 0, gender: 'f' })
  const TEXT = useContext(LocaleContext).calculator_drinks

  const [promille, setPromille] = useState(0)
  const [drinks, setDrinks] = useState<('beer' | 'wine' | 'snaps')[]>([])
  const handleChange = (prop: string, value: number | 'm' | 'f') => {
    setValues({ ...values, [prop]: value })
  }

  const calculate = () => {
    const { alcohol, weight, time, gender, size } = values
    const Reduktionsfaktor =
      gender === 'f'
        ? 0.31223 - 0.006446 * weight + 0.004466 * size
        : 0.31608 - 0.004821 * weight + 0.004432 * size

    const TheoBAK = alcohol / (weight * Reduktionsfaktor)
    const TheoBAKResorption = TheoBAK - (TheoBAK * 15) / 100
    const TheoBAKAbbau = TheoBAKResorption - time * 0.15
    const newfomula = alcohol / (weight * (gender === 'f' ? 0.55 : 0.68))

    return Math.max(0, +newfomula.toFixed(2)) //Math.max(0, +TheoBAKAbbau.toFixed(2))
  }

  const removeDrink = (type: 'beer' | 'wine' | 'snaps') => {
    let first = drinks.indexOf(type)
    if (first > -1) {
      let reduced = [...drinks]
      reduced.splice(first, 1)
      setDrinks(reduced)
      handleChange('alcohol', (drinks.length - 1) * 11)
    }
  }

  const addDrink = (type: 'beer' | 'wine' | 'snaps') => {
    setDrinks([...drinks, type])
    handleChange('alcohol', (drinks.length + 1) * 11)
  }

  useEffect(() => {
    setPromille(calculate())
  }, [values])

  const veryDarkColor = colorMode === 'dark' ? '#282828' : '#E9E9E9'
  const darkColor =
    colorMode === 'dark' ? 'rgba(0,0,0,.3)' : 'var(--petrol-dark-1)'
  const mainColor =
    colorMode === 'dark' ? 'var(--yellow-main)' : 'var(--petrol-main)'
  const arrowColor =
    colorMode === 'dark' ? 'var(--yellow-main)' : 'var(--petrol-main)'
  const textColor =
    colorMode === 'dark' ? 'var(--text-color)' : 'var(--text-color)'
  const alkoholcolor = colorMode === 'dark' ? '#FFE462' : '#2CA29F'
  const bodycolor = colorMode === 'dark' ? '#7D7D7D' : '#7D7D7D'
  const headcolor = colorMode === 'dark' ? '#7D7D7D' : '#D4D4D4'
  const bgcolor = colorMode === 'dark' ? '#282828' : '#E9E9E9'
  return (
    <PromilleRechnerRoot>
      <PromilleTitle bgcolor={veryDarkColor} textColor={textColor}>
        {TEXT[4]}
      </PromilleTitle>
      <InputRow style={{ backgroundColor: mainColor }}>
        <DrinksSelection>
          <div className='title'>{TEXT[5]}</div>
          {(['beer', 'wine', 'snaps'] as ('beer' | 'wine' | 'snaps')[]).map(
            (m, i) => {
              return (
                <ButtonWrapper className='a'>
                  <DrinksImage style={{ backgroundColor: darkColor }}>
                    <img
                      src={require('../../assets/bodyicons_' +
                        m +
                        '_drinks' +
                        (colorMode === 'dark' ? '_dm' : '') +
                        '.png')}
                    />
                    <DrinkButtonsWrapper>
                      <DrinkButton
                        onClick={() => addDrink(m)}
                        className='left'
                        style={{ backgroundColor: alkoholcolor }}
                      >
                        <img
                          src={require('../../assets/bodyicons_plus' +
                            (colorMode === 'dark' ? '_dm' : '') +
                            '.png')}
                        />
                      </DrinkButton>
                      <DrinkButton
                        onClick={() => removeDrink(m)}
                        className='right'
                        style={{ backgroundColor: alkoholcolor }}
                      >
                        <img
                          src={require('../../assets/bodyicons_minus' +
                            (colorMode === 'dark' ? '_dm' : '') +
                            '.png')}
                        />
                      </DrinkButton>
                    </DrinkButtonsWrapper>
                  </DrinksImage>
                  <div className='label'>
                    <div>{TEXT[i]}</div>
                  </div>
                </ButtonWrapper>
              )
            }
          )}
        </DrinksSelection>
        <DrinksDisplay>
          {drinks.length > 0 &&
            drinks
              .sort((a, b) => sortValues[a] - sortValues[b])
              .map((m) => {
                return (
                  <Drink onClick={() => removeDrink(m)}>
                    <img
                      src={require('../../assets/bodyicons_' +
                        m +
                        '_calc' +
                        (colorMode === 'dark' ? '_dm' : '') +
                        '.png')}
                    />
                  </Drink>
                )
              })}
          <AlkoholDisplay>
            <div className='alclabel'>{TEXT[3]}</div>
            <div className='alcvalue'>
              <b>{values.alcohol}</b>
            </div>
            <div className='alcunit'>g</div>
          </AlkoholDisplay>
        </DrinksDisplay>
      </InputRow>
      <InputRow style={{ backgroundColor: mainColor }}>
        <Switch
          label={TEXT[10] + ':'}
          isSwitched={values.gender === 'm'}
          elements={[
            <GenderButton
              colors={
                colorMode === 'dark'
                  ? [
                      'var(--site-background)',
                      'rgba(0,0,0,.3)',
                      'var(--yellow-main)',
                    ]
                  : [
                      'var(--petrol-dark-1)',
                      'var(--petrol-bright-1)',
                      'var(--site-background)',
                    ]
              }
              gender={values.gender}
              isActive={values.gender === 'f'}
            >
              {TEXT[6]}
            </GenderButton>,
            <GenderButton
              colors={
                colorMode === 'dark'
                  ? [
                      'var(--site-background)',
                      'rgba(0,0,0,.3)',
                      'var(--yellow-main)',
                    ]
                  : [
                      'var(--petrol-dark-1)',
                      'var(--petrol-bright-1)',
                      'var(--site-background)',
                    ]
              }
              gender={values.gender}
              isActive={values.gender === 'm'}
            >
              {TEXT[7]}
            </GenderButton>,
          ]}
          change={(isSwitched: boolean) =>
            handleChange('gender', isSwitched ? 'm' : 'f')
          }
        />
      </InputRow>
      <InputRow
        style={{
          border: '0',
          backgroundColor: mainColor,
          paddingBottom: '15px',
        }}
      >
        <Label className='wide'>
          <span>{TEXT[8]}:</span>
          <Input
            type={'number'}
            colors={
              colorMode === 'dark'
                ? ['var(--site-background)', 'var(--yellow-main)']
                : ['var(--site-background)', 'var(--petrol-main)']
            }
            placeholder={values.weight + ''}
            onChange={(e) => handleChange('weight', +e.target.value)}
          ></Input>
          kg
        </Label>{' '}
      </InputRow>{' '}
      <PromilleDisplay
        bgcolor={veryDarkColor}
        textColor={textColor}
        arrowColor={arrowColor}
      >
        <div className='resultvalue'>
          {isFinite(promille) ? promille || 0 : 0}
        </div>{' '}
        <div className='resultlabel'>{TEXT[9]}</div>
      </PromilleDisplay>
      <PromilleTabelle
        currentGroup={promille}
        alcoholcolor={alkoholcolor}
        headcolor={headcolor}
        bgcolor={bgcolor}
      />
    </PromilleRechnerRoot>
  )
}
const PromilleRechnerRoot = styled.div`
  color: var(--site-background);
  /* padding: 15px; */
  width: calc(100% - 0px);
  max-width: 100vw;
  .title {
    font-weight: 400 !important;
    flex: 0 0 100%;
    text-align: center;
    &.s {
      font-size: 15px;
    }
  }
`
const PromilleTitle = styled.div<{ bgcolor: string; textColor: string }>`
  color: ${({ textColor }) => textColor};
  line-height: 1.2em;
  padding: 30px;
  padding-top: 45px;
  padding-bottom: 45px;
  font-weight: 700;
  flex: 0 0 100%;
  text-align: center;
  font-size: 22px;

  margin-top: -15px;
  /* margin-bottom: 30px; */
  position: relative;
  background-color: ${({ bgcolor }) => bgcolor};
  &::after {
    content: '';
    position: absolute;

    left: calc(50% - 20px);
    bottom: -20px;
    width: 0;
    height: 0;
    border-left: 20px solid transparent;
    border-right: 20px solid transparent;

    border-top: ${({ bgcolor }) => '20px solid ' + bgcolor};
  }
`

const DrinksSelection = styled.div`
  display: flex;
  flex: 0 0 100%;
  justify-content: center;
  flex-wrap: wrap;
  gap: 10px;
  color: var(--site-background);
  padding-top: 30px;
`
const ButtonWrapper = styled.div`
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  justify-content: center;
  flex: 0 0 20%;
  gap: 10px;
  padding: 0;
  @media only screen and (max-width: 711px) {
    flex: 0 0 29%;
  }
  * {
    text-align: center;
    flex: 0 0 100%;
  }
  div.label {
    font-size: 15px;
    padding-top: 0px;
    letter-spacing: 0.2px;
    line-height: 1.1em;
    min-height: 3em;
    min-height: 100%;
  }
  img {
    margin-bottom: 15px;
  }
`
const DrinkButtonsWrapper = styled.div`
  display: inline-block;
  margin-bottom: 8px;
  max-width: calc(100% - 15px);
  display: flex;
  justify-content: center;
  gap: 2px;
  @media only screen and (max-width: 711px) {
    max-width: calc(100% - 10px);
    width: calc(100% - 10px);
  }
`
const DrinkButton = styled.button`
  display: inline-block;
  flex: 0 0 50%;
  margin: 0;
  background-color: transparent;
  border: 0;
  height: 50px;
  cursor: pointer;
  @media only screen and (min-width: 712px) {
    &:hover {
      opacity: 0.8;
    }
  }
  &.left {
    border-bottom-left-radius: 8px;
  }
  &.right {
    border-bottom-right-radius: 8px;
  }
  img {
    max-width: 30px !important;
    width: 60px;
    margin: 0;
    @media only screen and (max-width: 711px) {
      max-width: 20px !important;
      width: 20px;
    }
  }
`

const DrinksImage = styled.div`
  background-color: var(--petrol-dark-1);
  position: relative;
  /* margin: 5px; */
  padding-bottom: 0px;
  border-radius: 10px;
  padding-top: 10px;
  display: flex;
  flex-wrap: wrap;
  flex: 0 0 100%;
  justify-content: center;
  .label {
    flex: 0 0 100%;
  }
  img {
    max-width: 40%;
  }
  flex-wrap: wrap;
`
const PromilleDisplay = styled.div<{
  bgcolor: string
  textColor: string
  arrowColor: string
}>`
  display: flex;
  margin-left: -15px;
  margin-right: -15px;
  /* margin-bottom: -15px; */
  flex-wrap: wrap;
  background-color: ${({ bgcolor }) => bgcolor};
  color: ${({ textColor }) => textColor};
  padding: 30px;
  line-height: 1.6em;
  padding-top: 30px;
  position: relative;
  &::before {
    content: '';
    position: absolute;

    left: calc(50% - 20px);
    top: 0;
    width: 0;
    height: 0;
    border-left: 20px solid transparent;
    border-right: 20px solid transparent;

    border-top: ${({ arrowColor }) => '20px solid ' + arrowColor};
  }
  .resultlabel {
    flex: 0 0 100%;
    text-align: center;
  }
  .resultvalue {
    line-height: 1.2em;
    font-weight: 700;
    flex: 0 0 100%;
    text-align: center;
    font-size: 36px;
  }
`

const AlkoholDisplay = styled.div`
  flex: 0 0 100%;
  text-align: center;
  display: flex;
  justify-content: flex-start;
  align-items: center;
  gap: 0;
  margin-top: 15px;
  div.alclabel {
    flex: 0 0 calc(50% - 48px);
    line-height: 2em;
    text-align: right;
    padding-right: 10px;
    margin-right: 10px;
    @media only screen and (max-width: 711px) {
      font-size: 15px;
      line-height: 1.2em;
    }
  }
  div.alcvalue {
    flex: 0 0 60px;
    line-height: 2em;
    font-size: 22px;
    margin-right: 20px;
  }
  b {
    display: inline-block;
    min-width: 60px;

    /* background-color: var(--petrol-dark-1); */
  }
`
const InputRow = styled.div`
  display: flex;
  flex-wrap: wrap;
  border-bottom: 1px solid var(--site-background);
  padding-top: 10px;
  width: 100%;
  /* margin-bottom: 15px; */
`
const Label = styled.label`
  flex: 0 0 50%;
  display: inline-block;
  span {
    display: inline-block;
    width: calc(50% - 45px);
    text-align: right;
    @media only screen and (max-width: 711px) {
      font-size: 15px;
      line-height: 1.2em;
    }
  }
  &.wide {
    flex: 0 0 calc(100% - 5px);
  }
`
const Input = styled.input<{ colors: string[] }>`
  font-size: 22px;
  border: 0;
  color: var(--site-background);
  color: var(--text-color);
  max-width: 60px;
  margin-left: 10px;
  font-weight: 700;
  margin-right: 10px;
  text-align: center;
  padding: 10px;
  background-color: ${({ colors }) => colors[0]};
  ::placeholder {
    color: ${({ colors }) => colors[1]};
    font-size: 15px;
    font-weight: 200;
    font-style: italic;
  }
`

const GenderButton = styled.div<{
  gender: 'm' | 'f'
  isActive: boolean
  colors: string[]
}>`
  background-color: ${({ isActive, colors }) =>
    isActive ? colors[0] : colors[1]};
  color: ${({ isActive, colors }) => (isActive ? colors[2] : colors[2])};
  font-size: 18px;
  font-weight: ${({ isActive }) => (isActive ? '700' : '400')};

  padding: 15px;
`

const Switch = ({
  elements,
  isSwitched,
  change,
  label,
}: {
  elements: ReactNode[]
  isSwitched: boolean
  change: (e: boolean) => void
  label: string
}) => {
  const [switched, switchIt] = useState(isSwitched)

  useEffect(() => {
    change(switched)
  }, [switched])
  return (
    <SwitchRoot className={switched ? 'on' : 'off'}>
      <SwitchLabel>{label}</SwitchLabel>
      <SwitchButton onClick={() => switchIt(false)} disabled={!switched}>
        {elements[0]}
      </SwitchButton>
      <SwitchButton onClick={() => switchIt(true)} disabled={switched}>
        {elements[1]}
      </SwitchButton>
    </SwitchRoot>
  )
}

const SwitchRoot = styled.div`
  flex: 0 0 100%;
  display: flex;
  align-items: center;
  justify-content: flex-start;
  flex-wrap: wrap;
`
const SwitchLabel = styled.div`
  flex: 0 0 calc(50% - 48px);
  padding-right: 10px;
  text-align: right;
  @media only screen and (max-width: 711px) {
    font-size: 15px;
    line-height: 1.2em;
  }
`
const SwitchButton = styled.button`
  flex: 0 0 calc(25% + 10px);
  padding: 0;
  background-color: transparent;
  border: 0;
  &:hover:not(:disabled) {
    cursor: pointer;
    opacity: 0.8;
  }
`

const DrinksDisplay = styled.div`
  flex: 0 0 100%;
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
  align-items: flex-start;
  margin-top: 15px;
  padding: 0px;
  padding-top: 30px;

  /* padding-bottom: 2px;

  border-bottom: 1px solid rgba(255, 255, 255, 0.4);
  border-top: 1px solid rgba(255, 255, 255, 0.4);
  /* background-color: var(--petrol-dark-1); */
`

const Drink = styled.div`
  cursor: pointer;
  line-height: 0;
  &:hover {
    opacity: 0.8;
  }
  img {
    max-width: 40px;
  }
`
